import React from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'

import { StdCard } from 'components'
import { 
  bgCompanyRequestDetailPath,
  bgCompanyReportDetailPath
} from 'routes'
import { Cont } from './styled'

const BankGuaranteeRelatedComponent = (props) => {

  const { 
    valueForm,
    // props
  } = props

  const setBGRequestNumber = () =>{
    if(valueForm.referenceBgCompanyRequestNumber) return valueForm.referenceBgCompanyRequestNumber
    else return 'Link to BG Company Request'
  }

  const setBGExtenNumber = () =>{
    if(valueForm.referenceBgCompanyExtendNumber) return valueForm.referenceBgCompanyExtendNumber
    else return 'Link to BG Company Extend'
  }

  const setBGOriginalNumber = () =>{
    if(valueForm.referenceBgCompanyOriginalNumber) return valueForm.referenceBgCompanyOriginalNumber
    else return 'Link to BG Company Original'
  }

  const setListBGExtenNumber = (docNo) =>{
    if(docNo) return docNo
    else return 'Link to BG Company Extend'
  }

  return (
    <StdCard title={<span className='stepTitle'>Bank Guarantee Reference</span>}>
      <Cont>
        {valueForm.referenceBgCompanyRequestId?
        <div>
          Reference Request No.({valueForm.documentType=='Original'?'New':'Extend'}) : 
          <a href={bgCompanyRequestDetailPath(valueForm.referenceBgCompanyRequestId)} target="_blank">{setBGRequestNumber()}</a>
        </div>:null}
        {valueForm.referenceBgCompanyOriginalId?
        <div>
          Original BG No. : 
          <a href={bgCompanyReportDetailPath(valueForm.referenceBgCompanyOriginalId)} target="_blank">{setBGOriginalNumber()}</a>
        </div>:null}
        {valueForm.referenceBgCompanyExtendId?
        <div>
          Extend BG No. : 
          <a href={bgCompanyReportDetailPath(valueForm.referenceBgCompanyExtendId)} target="_blank">{setBGExtenNumber()}</a>
        </div>:null}
        {valueForm.extendedLists&&valueForm.extendedLists.length>0?
        valueForm.extendedLists.map((i)=>{
          return(
            <div>
              Extend BG No. : 
              <a href={bgCompanyReportDetailPath(i.id)} target="_blank">{setListBGExtenNumber(i.documentNumber)}</a>
            </div>
          )
        }):null}
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompany')(state) || {},
  }
}

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeRelatedComponent)
